export const activityDetailConstants = {
  DETAIL_STATUS_REQUEST: "ACTIVITY_DETAIL_STATUS_REQUEST",
  DETAIL_STATUS_SUCCESS: "ACTIVITY_DETAIL_STATUS_SUCCESS",
  DETAIL_STATUS_FAILURE: "ACTIVITY_DETAIL_STATUS_FAILURE"
};
